import { UserRole } from 'network-utils';

const getPlatformPath = (path: string): string => {
    if (process.env.CB_PLATFORM_CLIENT_URL) {
        return `${process.env.CB_PLATFORM_CLIENT_URL}${path}`;
    }

    return path;
};

const homepageByRole = {
    user: '/app/home',
    manager: getPlatformPath('/manager/dashboard'),
    admin: getPlatformPath('/dashboard'),
    superAdmin: getPlatformPath('/admin/dashboard')
};

export const getHomepage = (role: keyof typeof UserRole): string => {
    return homepageByRole[role];
};

export default getHomepage;
